// Blocked CartBot in Cart page
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.includes("/cart")) {

        (function(originalFetch) {
            window.fetch = function(url, options) {
                if (typeof url === "string" && url.includes("cart.json?cartbot-cart-call")) {
                    return new Promise((resolve, reject) => {});
                }
                return originalFetch(url, options);
            };
        })(window.fetch);
    }

    // Remove Cart on Cart page
    document.querySelectorAll('a[is="cart-remove-item"]').forEach(link => {
        link.addEventListener("click", async function (event) {
            event.preventDefault();

            let cart = await fetch("/cart.json").then(res => res.json());
            let productId = new URL(link.href).searchParams.get("id");
            let product = cart.items.find(item => item.key === productId);

            if (product?.final_line_price === 0 && cart.total_price > 0) return;

            await fetch(link.href, { method: "POST" });
            let updatedCart = await fetch("/cart.json").then(res => res.json());

            if (updatedCart.item_count && !updatedCart.total_price) 
                await fetch("/cart/clear", { method: "POST" });

            location.reload();
        });
    });
});